module.exports = __webpack_public_path__ + "static/formigio-app-pages-7523990caa7324cb8577ac60b9089bb0.png";